import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "breadcrumb-content" }

import { BreadType } from '@/typeDefine/EntityType';
import { ArrowRight } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    breadList: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, {
      "separator-icon": _unref(ArrowRight),
      class: "breadcrumb"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('index.navBar.home')), 1)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.breadList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: index,
            to: item.to
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(item.text)), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["separator-icon"])
  ]))
}
}

})